import { useThree } from '@react-three/fiber';
import React, { useEffect, useState } from 'react';
import { Box3, GridHelper, Object3D, type Object3DEventMap, Vector3 } from 'three';

interface GridWithLabelsProps {
  model: Object3D<Object3DEventMap>;
}

const GridWithLabels: React.FC<GridWithLabelsProps> = ({ model }) => {
  const { size } = useThree();
  const [grid, setGrid] = useState<Object3D<Object3DEventMap> | undefined>();

  useEffect(() => {

    const boundingBox = new Box3().setFromObject(model);
    const size = boundingBox.getSize(new Vector3());
    const center = boundingBox.getCenter(new Vector3());

    const gridObject = new Object3D();

    const config = {
      linesWidth: 15,
      color: 0xffffff,
      fontSize: size.x / 20,
      fontColor: 0xffffff,
    };

    let { x: width, z: depth } = size;
    const maxDimension = Math.max(width, depth);

    const offset = maxDimension / config.linesWidth;
    const widthOffset = offset * (width / maxDimension);
    const depthOffset = offset * (depth / maxDimension);

    width += widthOffset;
    depth += depthOffset;

    const maxDimensionCalculated = Math.max(width, depth);

    const gridHelper = new GridHelper(maxDimensionCalculated, config.linesWidth, config.color, config.color);
    gridHelper.position.set(center.x, boundingBox.min.y - 0.001, center.z);

    gridObject.add(gridHelper);

    setGrid(gridObject);
  }, [model, size]);

  return grid ? <primitive object={grid} /> : null;
};

export default GridWithLabels;
